/**
 * Draws the highlighter pen stroke (see text-highlight.css) when text that is both italic and underlined scrolls into view.
 *
 * Only strokes below the fold when the page loads are held back, so nothing above the fold is delayed and nothing stays
 * hidden if this script does not run. The script does nothing in the theme editor, with reduced motion, or without
 * IntersectionObserver: the stroke is then simply drawn.
 */
const SELECTOR = ':is(em, i) u, u :is(em, i)';

const isDesignMode = Boolean(window.Shopify?.designMode);
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/**
 * @param {IntersectionObserverEntry[]} entries
 * @param {IntersectionObserver} observer
 */
function draw(entries, observer) {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return;

    /** @type {HTMLElement} */ (entry.target).dataset.highlight = 'done';
    observer.unobserve(entry.target);
  });
}

function init() {
  const observer = new IntersectionObserver(draw, { rootMargin: '0px 0px -12% 0px', threshold: 0.6 });

  document.querySelectorAll(SELECTOR).forEach((node) => {
    const element = /** @type {HTMLElement} */ (node);

    // Already in view when the page loads: leave it drawn
    if (element.getBoundingClientRect().top < window.innerHeight) return;

    element.dataset.highlight = 'pending';
    observer.observe(element);
  });
}

if (!isDesignMode && !prefersReducedMotion && 'IntersectionObserver' in window) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
}
